import { Box, IconButton, TableCell, Typography, Table } from '@material-ui/core'
import styled from 'styled-components/macro'
import { ReactComponent as Delete } from 'icons/delete.svg'
import { Button } from 'common/atoms/Button/Button'

export const StyledTableHead = styled(TableCell)`
  && {
    color: ${props => props.theme.colors.accent1};
    font-weight: bold;
    border-radius: 30rem;
    border-bottom-color: ${props => props.theme.colors.primaryLight};
    border-width: 3;
  }
`
export const StyledTtileAdmin = styled(TableCell)`
  && {
    color: ${props => props.theme.colors.accent};
    font-weight: 500;
    font-size: 16px;
    line-height: 5px;
    line-height: initial;
    border-bottom-color: ${props => props.theme.colors.supplementary1};
    border-bottom-width: 1px;
    font-family: ${props => props.theme.fonts.primary};
    padding-bottom: 1em;
  }
`
export const StyledAdminText = styled(TableCell)`
  && {
    color: ${props => props.theme.colors.accent1};
    border-bottom-color: ${props => props.theme.colors.supplementary1};
    border-bottom-width: 1px;
    background-color: ${props => props.theme.colors.supplementary};
    font-weight: bolder;
    font-size: 16px;
    line-height: 16px;
    word-spacing: 6px;
    font-family: ${props => props.theme.fonts.primary};
    overflow: hidden;
    line-break: anywhere;
    overflow-wrap: break-word;
  }
`

export const StyledTableBody = styled(TableCell)`
  && {
    color: ${props => props.theme.colors.accent1};

    font-weight: bold;
    border-bottom-color: ${props => props.theme.colors.accent1};
    background-color: ${props => props.theme.colors.supplementary};
    border-width: 1;
  }
`
export const ViewUserItemContainer = styled(Box)`
  && {
    display: flex;
    justify-content: flex-start;
    align-items: flex-start;
    padding: 8px;
    font-weight: bolder;
    font-size: 14px;
    line-height: 16px;
    border: none;
    box-shadow: none;
  }
`

export const UserGroupCardItemContainer = styled(Box)`
  && {
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 8px;
    font-weight: bolder;
    line-height: 16px;
    border: none;
    box-shadow: none;
    flex-direction: row;
  }
`

export const UserGroupCardItemSubContainer = styled(Box)`
  && {
    display: flex;
    justify-content: flex-start;
    align-items: flex-start;
    flex-direction: column;
    font-weight: bolder;
    font-size: 14px;
    line-height: 16px;
    border: none;
    box-shadow: none;
    width: 100% !important;
  }
`

export const UserGroupCardTextContainer = styled(Box)`
  && {
    width: 100%;
  }
`

export const ViewGroupItemContainer = styled(Box)`
  && {
    display: flex;
    justify-content: flex-start;
    font-size: 18px;
    font-weight: 'bold';
    align-items: flex-end;
    margin: 0 0 1rem 0;
    box-shadow: none;
  }
`

export const StyledTableBodyPartner = styled(TableCell)<{ isDisabled: boolean }>`
  && {
    color: ${props => (props.isDisabled ? props.theme.colors.accent : props.theme.colors.accent1)};

    font-weight: bold;
    border-bottom-color: ${props => props.theme.colors.supplementary};
    background-color: ${props => props.theme.colors.supplementary1};
    border-width: 1;
  }
`

export const StyledTableBodyPartnerDevice = styled(TableCell)<{ isDisabled: boolean }>`
  && {
    color: ${props => (props.isDisabled ? props.theme.colors.accent : props.theme.colors.accent1)};
  }
`
export const StyledTableBodyDevice = styled(TableCell)`
  && {
    color: ${props => props.theme.colors.accent1};
    font-weight: bold;
    border-bottom-color: ${props => props.theme.colors.supplementary};
    background-color: ${props => props.theme.colors.supplementary};
    border-radius: 0.5em;
    border-width: 1;
    padding: 1em;
  }
`

export const StyledIconButton = styled(IconButton)`
  && {
    .MuiTypography-root {
      color: ${props => props.theme.colors.accent1};
      line-height: 1em;
      font-weight: bold;
      font-size: 12px;
    }
    padding: 0;
  }
`
export const StyledBox = styled(Box)`
  padding: 0 1em;
  width: 100%;
  margin: -0.4rem 0 1em 0;
`

export const StyledText = styled.div`
  font-weight: bolder;
  font-size: 16px;
  color: ${props => props.theme.colors.accent1};
  padding: 0 0 1em 0;
`
export const StyledGroupsBox = styled(Box)`
  position: fixed;
  background-color: ${props => props.theme.colors.supplementary1};
  border-radius: 8px 8px;
  width: 92%;
`
export const StyledInText = styled(Box)`
  width: 100%;
  display: flex;
  flex-direction: column;
  padding: 0.5rem 0 0.5rem 2.7rem;
  font-weight: 600;
`

export const StyledViewPartnerUsersModalTitle = styled.p`
  font-weight: 700;
  font-size: 20px;
  line-height: 23px;
  margin-left: 45px;
`
export const StyledUserGroupContainer = styled.div`
  max-height: ${p => document.body.clientHeight - 300}px;
  overflow: auto;
  margin-bottom: 10px;
`
export const StyledButtonNum = styled(Button)`
  && {
    text-decoration-line: underline;
    color: ${props => props.theme.colors.primary};
    font-weight: 700;
    font-size: '16px';
    padding: initial;
    .MuiButton-root {
      min-width: 0px;
    }
    .MuiButton-label {
      justify-content: left;
    }
  }
`
export const StyledTopTitle = styled(Box)`
  && {
    padding-top: 0.6rem;
    padding-bottom: 0.6rem;
    display: flex;
    align-items: center;
  }
`
export const StyledUserText = styled(Typography)`
  && {
    font-style: normal;
    font-weight: 500;
    font-size: 0.88rem;
    line-height: 1.31rem;
    overflow: hidden;
    overflow-wrap: break-word;
    width: 90%;
    padding: 3px;
  }
`
export const StyledUserLabel = styled(Typography)`
  && {
    font-style: normal;
    font-weight: 500;
    font-size: 0.78rem;
    line-height: 1.31rem;
    overflow: hidden;
    overflow-wrap: break-word;
    width: 90%;
  }
`

export const StyledUserMainText = styled(Typography)`
  && {
    font-style: normal;
    font-weight: 500;
    font-size: 1.1rem;
    line-height: 1.31rem;
    overflow: hidden;
    overflow-wrap: break-word;
    width: 90%;
    padding: 3px;
  }
`

export const StyledDeleteUserButton = styled(Delete)`
  && {
    margin-right: 1em;
    font-size: 1em;
    cursor: pointer;
    fill: ${props => props.theme.colors.primary};
  }
`
export const StyledMiddleContentContainer = styled(Box)`
  flex-direction: row;
  justify-content: space-between;
  align-items: flex-start;
  display: flex;
  padding-left: 10px;
`
export const StyledUserGroupPageContainer = styled(Box)`
  margin: 2px;
`

export const StyledBorderLine = styled(Box)`
  && {
    height: 1px;
    width: 92%;
    background-color: ${props => props.theme.colors.bgPrimary};
    margin: -6px auto 0;
  }
`
export const StyledAdminTable = styled(Table)`
  && .MuiTableCell-stickyHeader {
    background-color: ${props => props.theme.colors.supplementary} !important;
  }
`
